export default class ConversationDepartmentModel {
  id!: number;

  nome!: string;

  nomeDepartamento!: string;

  ativo!: number;
}
